/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Schoolsupport1Inputs */

const de__field_schoolsupport1 = /** @type {(inputs: _Field_Schoolsupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schulteambegleitung`)
};

/**

* @param {_Field_Schoolsupport1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_schoolsupport1 = /** @type {((inputs?: _Field_Schoolsupport1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Schoolsupport1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_schoolsupport1(inputs)
});
export { _field_schoolsupport1 as "_field_schoolSupport" }